import { injectable } from "inversify-props"
import { AxiosRequestConfig } from "axios"
import { EmbalagemServiceAdapter } from "@/usecases/produto/embalagem"
import { Embalagem } from "@/models/Embalagem"
import { criar, editar, listarPorLoja } from "@/api/embalagem"

@injectable()
export class EmbalagemService implements EmbalagemServiceAdapter {
	listarPorLoja = async (lojaId: string, params?: any, config?: AxiosRequestConfig) => await listarPorLoja(lojaId, params, config)
	criar = async (embalagem: Embalagem) => await criar(embalagem)
	editar = async (embalagem: Embalagem) => await editar(embalagem)
}